/*
 * Copyright (C) 2009-2025 SonarSource Sàrl
 * All rights reserved
 * mailto:info AT sonarsource DOT com
 */

import { Component } from '~sq-server-commons/types/types';
import { SandboxInstanceSetting } from './SandboxInstanceSetting';
import { SandboxProjectSetting } from './SandboxProjectSetting';

export function SandboxSettingContainer({ component }: Readonly<{ component?: Component }>) {
  if (component) {
    return <SandboxProjectSetting component={component} />;
  }

  return <SandboxInstanceSetting />;
}
